import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { subscribeToPush, initForegroundMessages, pushPermission } from '../services/pushService';

// Login qilingandan keyin push'ga avtomatik obuna bo'ladi (ruxsat allaqachon berilgan bo'lsa yoki native ilovada).
// Ruxsat hali so'ralmagan bo'lsa — NotificationBell ichidagi "Push yoqish" tugmasi (foydalanuvchi bosishi shart).
// Brauzer ochiq paytda (ko'rinib turgan yoki fondagi tab) push kelsa:
//   - 'erp:notif' hodisasi bilan bell/toast ro'yxati darrov yangilanadi;
//   - shoshilinch xabar (yangi zakaz/vazifa) bo'lsa — baland jiringlash chalinadi.
// Eslatma: brauzer saytda birinchi bosishdan (click) oldin ovoz chalishni bloklaydi — bu oddiy holat, xato emas.
let bell = null;
function playBell() {
  try {
    if (!bell) { bell = new Audio('/urgent_bell.mp3'); bell.volume = 1; }
    bell.currentTime = 0;
    const p = bell.play();
    if (p && p.catch) p.catch(() => { /* autoplay bloklangan */ });
  } catch { /* ignore */ }
}

export default function PushInit() {
  const isAuth = useSelector(s => s.auth.isAuthenticated);

  useEffect(() => {
    if (!isAuth) return undefined;
    if (pushPermission() === 'granted' || window.ERPlineNative) subscribeToPush({ interactive: false });

    let unsub = () => {};
    let alive = true;
    initForegroundMessages(() => window.dispatchEvent(new Event('erp:notif')))
      .then(u => { if (alive) unsub = u; else u?.(); });

    // Service worker har push'da ochiq oynalarga xabar yuboradi.
    const onSwMessage = (e) => {
      if (e.data?.type !== 'erp-push') return;
      window.dispatchEvent(new Event('erp:notif'));
      if (e.data.loud) playBell();
    };
    navigator.serviceWorker?.addEventListener('message', onSwMessage);

    return () => {
      alive = false; unsub?.();
      navigator.serviceWorker?.removeEventListener('message', onSwMessage);
    };
  }, [isAuth]);

  return null;
}
